<script>
  import { createEventDispatcher } from 'svelte';
  import EditButton from './EditButton.svelte';
  import DeleteButton from './DeleteButton.svelte';
  import Fa from 'svelte-fa';
  import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
  import Notification from "carbon-icons-svelte/lib/NotificationFilled16";
  import NotificationOff from "carbon-icons-svelte/lib/NotificationOffFilled16";

  const dispatch = createEventDispatcher();

  const updown = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADr8AAA6/ATgFUyQAAABhSURBVChTrZFRDsAgCENhFxyeVHZCFxoxiCHZx96PpjRSkMcYFFF9IIjcDGFyzRO4yYh3YxlzwYganu9dD1PEYmytK5i3uD/xPWPeYwWGycuNeA0/41PlCK1JPa6Zz8xEL1z4LUAzwsTbAAAAAElFTkSuQmCC";
  const up = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA/SURBVChT7c7BDQAgCANA6v47o23AgNENvA+k9AHc3SoAClYOBWHElCxR3WkXzwPVTMVbKeWNfzxLVfvx68wmhbUOE+YSOnoAAAAASUVORK5CYII=";
  const down = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA2SURBVChTYxiRgBGI/0OY+AETlCYImP7//w8yFS8AqQGbiE8xTA5uNTbFyGIobkSWQNXIwAAAr/4Y+65JQVsAAAAASUVORK5CYII=";

  export let visible = true;
  export let columns = null;
  export let hideColumns = null;
  export let data = [];
  export let search = "";
  export let banded = false;
	export let sortable = false;
  export let subscribable = false;
  export let editable = false;
  export let deletable = false;
  export let editOnLeft = false;
  export let deleteOnLeft = false;
  export let sortCol = null;
  export let sortAsc = true;

  $: cols = getColumns(columns, data);
  $: processedData = setBanded(sortData(setVisible(data, search), sortCol, sortAsc));
  $: hasVisible = processedData && processedData.length > 0 && processedData.some(x => x.visible);

  export function setData(newData) {
    data = newData;
  }

  function getColumns(columnsArray, dataArray) {
    if (columnsArray) return columnsArray;
    
    if (dataArray && dataArray.length > 0) {
      let keys = Object.keys(data[0]);
      return keys;
    }

    return [];
  }

  function setVisible(dataToFilter, searchString) {
    searchString = searchString.toLowerCase();
    
    if (searchString === "[subscribed]") {
      for (const row of dataToFilter) {
        row.visible = row.Subscribed;
      }
      return dataToFilter;
    } else if (searchString === "[!subscribed]") {
      for (const row of dataToFilter) {
        row.visible = !row.Subscribed;
      }
      return dataToFilter;
    }

    if (!dataToFilter) return [];

    for (const row of dataToFilter) {
      const values = getValues(row);
      let visible = false;
      for (let col = 0; col < values.length; col++) {
        if (getFormattedValue(col, values[col])?.toString().toLowerCase().includes(searchString)) {
          visible = true;
          break;
        }
      }
      row.visible = visible;
    }

    return dataToFilter;
  }

  function sortData(dataToSort, column, ascending) {
    if (!dataToSort) return;
    if (!column) return dataToSort;

    const colName = getColumnName(column);
    const colIndex = getColumnIndex(colName);
    return dataToSort.sort((a, b) => compare(a, b, colIndex, ascending));
    //return sorted.sort((a,b) => compareStarred(a, b));
  }

  // To get subscribed items on top
  function compareSubscribed(a, b)
  {
    if (a.Subscribed && b.Subscribed) return 0;
    if (a.Subscribed) return -1;
    if (b.Subscribed) return 1;
  }

  function setBanded(dataToBand) {
    if (!banded || !dataToBand || dataToBand.length === 0) return dataToBand;

		let isBanded = true;
    for (let i = 0; i < dataToBand.length; i++) {
			if (dataToBand[i].visible) {
				isBanded = !isBanded;
			}
			dataToBand[i].banded = dataToBand[i].visible && isBanded;
		}
		return dataToBand;
  }

  const numRegex = /^(\d+.?\d*)/; // To extract number from text starting with number
  function compare(a, b, colIndex, ascending) {
    const num = ascending ? 1 : -1;
    
    let aValue = (getValues(a)[colIndex]);
    let bValue = (getValues(b)[colIndex]);

    // Extract number from text starting with number
    if (typeof aValue === "string" && numRegex.test(aValue.replace(" ", ""))) aValue = aValue.replace(" ", "").match(numRegex)[1];
    if (typeof bValue === "string" && numRegex.test(bValue.replace(" ", ""))) bValue = bValue.replace(" ", "").match(numRegex)[1];

    // Convert number as text to number
    if (Number(aValue)) aValue = Number(aValue);
    if (Number(bValue)) bValue = Number(bValue);
    
    if (typeof aValue === "string") aValue = aValue.toLowerCase();
    if (typeof bValue === "string") bValue = bValue.toLowerCase();

    if (aValue === bValue) return 0;
    if (aValue == null || aValue?.length === 0) return 1;
    if (bValue == null || bValue?.length === 0) return -1;
    return aValue > bValue ? num : -num;
  }

  function getColumnName(column) {
    return column.name || column;
  }

  function getColumnIndex(colName) {
    return cols.map(x => getColumnName(x)).indexOf(colName);
  }

  function getValues(row) {
    let values = [];
    if (cols && cols.length) {
      for (let col of cols) {
        if (col.value) values.push(col.value(row));
        else if (row.hasOwnProperty(col.name)) values.push(row[col.name]);
      }
    }

    if (values.length === 0)
      values = Object.values(row);
    
    if (hideColumns) {
      let keys = Object.keys(row);
      let hideIndicies = hideColumns.map(col => keys.indexOf(col));
      hideIndicies.sort((a, b) => (a > b ? -1 : 1));
      for (let index of hideIndicies)
        if (index >= 0) values.splice(index, 1);
    }

    return values;
  }

  function getFormattedValue(columnIndex, value) {
    return cols[columnIndex]?.formatter ? cols[columnIndex].formatter(value) : value;
  }

  function onColumnClick(column) {
		if (!sortable) return;
		
    if (getColumnName(column) === sortCol) sortAsc = !sortAsc;
    else {
      sortCol = getColumnName(column);
      sortAsc = true;
    }
  }

  function onEdit(index, data) {
    dispatch("edit", { index, data });
  }

  function onDelete(index, data) {
    dispatch("delete", { index, data });
  }

  function onStarClicked(data) {
    data.hover = false;
    dispatch("starClicked", { data });
  }

  function onStartHeaderClicked(star) {
    dispatch("starHeaderClicked", { data: processedData.filter(x => x.visible), star });
  }
</script>

<div class="container" class:visible>
  <table>
    <thead>
      <tr class:visible>
        {#if hasVisible}
          {#if deletable && deleteOnLeft}<th></th>{/if}
          {#if editable && editOnLeft}<th></th>{/if}
        {/if}
        {#each cols as col}
          <th class="noselect" class:sortable on:click={() => onColumnClick(col)}>
            <div class="headercol">
              {col.name || col}
              <img src={sortCol === (col.name || col) ? sortAsc ? up : down : updown} alt="sort arrow" class="sortbutton" class:hidden={!sortable} />
            </div>
          </th>
        {/each}
        {#if hasVisible}
          {#if editable && !editOnLeft}<th></th>{/if}
          {#if deletable && !deleteOnLeft}<th></th>{/if}
        {/if}
        {#if hasVisible && subscribable}
          <th>
            <div style="display: flex">
              {#if processedData.filter(x => x.visible).every(x => x.Subscribed)}
                <Notification title="Unsubscribe to all visible" style="fill: #9d4b4b; cursor: pointer;" on:click={() => onStartHeaderClicked(false)} />
              {:else if processedData.filter(x => x.visible).some(x => x.Subscribed)}
                <Notification title="Subscribe to all visible" style="fill: #aaa; cursor: pointer;" on:click={() => onStartHeaderClicked(true)} />
              {:else}
                <NotificationOff title="Subscribe to all visible" style="fill: #aaa; cursor: pointer;" on:click={() => onStartHeaderClicked(true)} />
              {/if}
            </div>
          </th>
        {/if}
      </tr>
    </thead>
    <tbody>
      {#each processedData as rowData, i}
        <tr class:visible={rowData.visible} class:hover={rowData.hover}>
          {#if hasVisible}
            {#if deletable && deleteOnLeft}<td class="buttoncell" class:banded={rowData.banded}><DeleteButton on:click={() => onDelete(i, rowData)} /></td>{/if}
            {#if editable && editOnLeft}<td class="buttoncell" class:banded={rowData.banded}><EditButton on:click={() => onEdit(i, rowData)} /></td>{/if}
          {/if}
          {#each getValues(rowData) as value, col}
            <td class:banded={rowData.banded}>
              <div class="cell">
                {#if cols[col]?.component}
                  {#if cols[col]?.props}
                    <svelte:component this={cols[col].component} value={getFormattedValue(col, value)} {...cols[col].props(rowData)} on:click={cols[col]?.clickHandler} />
                  {:else}
                    <svelte:component this={cols[col].component} value={getFormattedValue(col, value)} on:click={cols[col]?.clickHandler} />
                  {/if}
                {:else}
                  {getFormattedValue(col, value)}
                {/if}

                {#if cols[col]?.alert && cols[col]?.alert(rowData) || false}
                  <div title={cols[col]?.alertTooltip || ""}>
                    <Fa icon={faExclamationCircle} color="red" style="margin-left: 5px" />
                  </div>
                {/if}

                {#if cols[col]?.extra || false}
                  <span class="extra">{cols[col].extra(rowData)}</span>
                {/if}
              </div>
            </td>
          {/each}
          {#if hasVisible}
            {#if editable && !editOnLeft}<td class="buttoncell" class:banded={rowData.banded}><EditButton on:click={() => onEdit(i, rowData)} /></td>{/if}
            {#if deletable && !deleteOnLeft}<td class="buttoncell" class:banded={rowData.banded}><DeleteButton on:click={() => onDelete(i, rowData)} /></td>{/if}
          {/if}
          {#if hasVisible && subscribable}
            <td style="width: 15px;">
              <div class="cell">
                {#if rowData.Subscribed}
                  <Notification title="Unsubscribe to all visible" style="fill: #9d4b4b; cursor: pointer;" 
                    on:mouseenter={() => rowData.hover = true}
                    on:mouseleave={() => rowData.hover = false}
                    on:click={() => onStarClicked(rowData)} />
                {:else}
                  <NotificationOff title="Subscribe to all visible" style="fill: #aaa; cursor: pointer;" 
                    on:mouseenter={() => rowData.hover = true}
                    on:mouseleave={() => rowData.hover = false}  
                    on:click={() => onStarClicked(rowData)} />
                {/if}
              </div>
            </td>
          {/if}
        </tr>
      {/each}
    </tbody>
	</table>
</div>

<style>
  .container {
    display: none;
    width: 100%;
    overflow-y: auto;
    font-size: 14px;
  }

  .container.visible {
    display: block;
  }

  table {
    table-layout: auto !important;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px;
    border-left: 1px solid #ccc;

    /* Fix for border issue */
    outline: 1px solid white;
  }

  th, td {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    text-align: left;
    padding: 4px 6px;
  }

  thead {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  th {
    background-color: #f9fafb;
    color: #6c727f;
  	border-top: 1px solid #ccc;
  }

  th.sortable:not(:empty):hover {
    background-color: #e5e7eb;
  }

  td.banded {
    background-color: #dfe2ee70;
  }

  th.sortable:not(.buttoncell) {
    cursor: pointer;
  }

  tr:not(.visible) {
    display: none;
  }

  tr.hover {
    background-color: #f3d2d0;
  }

  .headercol {
    display: grid;
    grid-template-columns: auto 12px;
    align-items: center;
  }

  .cell {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }

  .extra {
    color: #888;
    font-size: 11px;
    margin-left: 10px;
  }

  .buttoncell {
    width: 1%;
    white-space: nowrap;
    padding: 3px;
  }

  .sortbutton {
    padding-left: 5px;
  }

  .hidden {
    display: none;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Old versions of Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
  }
</style>